import React from 'react';
import { IRoleForUser } from '../../../services/rolesAndPermissions/rolesAndPermissions.types';

export enum RoleActivity {
  active,
  inActive,
  all,
}

export interface IRoleListProps {
  roles: IRoleForUser[];
  onToggleRolesActivity: (id: string) => void;
  userId: string;
}
